
import { provideMockStore } from '@ngrx/store/testing';
import {
  WithoutMetaButAllowId,
  DxDocument
} from '@digitaix/types';

export function getStoreStateWithDocuments<Document extends WithoutMetaButAllowId<DxDocument>>(collectionPath: string, documents: Document[]) {
  return {
    dx: {
      documents: {
        [collectionPath]: {
          ids: documents.map(d => d.id),
          entities: documents.reduce((entities, document) => ({ ...entities, [document.id]: { collectionPath, ...document } }), {})
        }
      }
    }
  }
}

export function provideMockStoreWithDocuments<Document extends WithoutMetaButAllowId<DxDocument>>(collectionPath: string, documents: Document[]) {
  return provideMockStore({
    initialState: getStoreStateWithDocuments<Document>(collectionPath, documents),
  })
}
